module.exports = __webpack_public_path__ + "static/ManagementPlan-d1e2909cfc1ac6f2357e72fba5fc43a7.pdf";